<!-- 热切图 -->
<template>
  <div class="wh__cut-image-wrapper">
    <div class="cut-image-div">
      <img :src="$cvWebpFn(props.data.image, { w: 828 })" :loading="eager || priority ? 'eager' : 'lazy'" :fetchpriority="priority ? 'high' : 'auto'" class="cur-img" />
      <!-- <ClientOnly>
        <template #fallback>
          <img :src="useImg1pxBase64().value" alt="" lazy="loading" class="cur-img">
        </template>
      </ClientOnly> -->

      <div
        v-for="(item, index) in props.data.item"
        :key="index"
        :style="get_location_fn(item, index)" 
        class="cut_click_item"
        @click="handleClick(item)"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { getImageFileNameFromUrl } from '@/plugins/utils'

interface cutImage {
  /** 图片地址URL */
  image: string,
  /** 切图配置项 */
  item: [{
    /** 切图定位 width, height, left, top */
    location: string,
    /** 圆半径 border-radius 例：50%\50px\50rem */
    radius: string
    /** 操作类型 */
    type: string,
    /** 操作数据 */
    data: string
  }]
}

const { $cmsGoTo } = useNuxtApp()

const props = withDefaults(
  defineProps<{
    data: cutImage
    /** 首页热切图：跳转时写入 Banner|centerBanner 埋点 source */
    trackHomeBannerSource?: boolean
    priority?: boolean
    eager?: boolean
  }>(),
  { trackHomeBannerSource: false, priority: false, eager: true }
)

const get_location_fn = computed(() => {
  return (item: any, index: number) => {
    return {
      width: item.location[0],
      height: item.location[1],
      left: item.location[2],
      top: item.location[3],
      borderRadius: item.radius,
      zIndex: 10 + index
    }
  }
})

const handleClick = (item: any) => {
  const { type, data } = item

  if (props.trackHomeBannerSource) {
    $cmsGoTo(type, data, {
      trafficSourceScene: 'homeCenterBanner',
      sourceValue: getImageFileNameFromUrl(props.data.image) || ''
    })
    return
  }

  $cmsGoTo(type, data)
}
</script>

<style lang='scss' scoped>
.wh__cut-image-wrapper{
  overflow: hidden;
  border-radius: 10px;
}
.cut-image-div {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  position: relative;
  border-radius: 10px;
  .cur-img{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
  
  .cut_click_item {
    opacity: 0;
    overflow: hidden;
    display: block;
    position: absolute;
    background-color: rgba(255,255,255,0.2);
  }
}
</style>
